// Small shared fetch helper for /api/admin/commercial/* - follows the
// same plain-fetch + Bearer-token convention as MainBoard.jsx rather than
// introducing axios, which is a dependency here but unused by every
// existing dashboard file.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export async function commercialGet(path, token, params = {}) {
  const query = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '')),
  ).toString();
  const url = `${API_BASE_URL}/admin/commercial${path}${query ? `?${query}` : ''}`;

  const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error(body.error || `HTTP ${r.status}`);
  }
  return r.json();
}

export async function commercialPost(path, token, body) {
  const r = await fetch(`${API_BASE_URL}/admin/commercial${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data;
}

export async function commercialPut(path, token, body) {
  const r = await fetch(`${API_BASE_URL}/admin/commercial${path}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data;
}
